import { useMsal } from "@azure/msal-react";
import createAxiosInstance from "../utils/axiosCustomize";

const TeamService = () => {
  const { instance, accounts } = useMsal();
  const axiosInstance = createAxiosInstance(instance, accounts);

  const getTeams = () => {
    return axiosInstance.get("/Team/teams")
  }

  const getTeamInfo = (idTeam, signal) => {
    return axiosInstance.get("Team/info", {
      params: { idTeam },
      signal
    })
  }

  const getTeamMembers = (idTeam, nextPageUrl, signal) => {
    return axiosInstance.get("Team/members", {
      params: { idTeam, nextPageUrl },
      signal
    })
  }

  const getSearchUsers = (nameormail, signal) => {
    return axiosInstance.get("Team/search", {
      params: { nameormail },
      signal
    })
  }

  const postExistUsers = (arr) => {
    return axiosInstance.post("Team/existUsers", arr)
  }

  const postCreateTeam = (object) => {
    return axiosInstance.post("Team/team", object)
  }

  const postAddMembers = (idTeam, members) => {
    const object = { members };
    return axiosInstance.post(`Team/team/${idTeam}/members`, object)
  }

  return { getTeams, getTeamInfo, getTeamMembers, getSearchUsers, postExistUsers, postCreateTeam, postAddMembers }
}

export default TeamService;